<template>
    <div class="input-text">
        <Textarea
            id="description"
            rows="5"
            cols="100"
            style="resize: none"
            :name="`${step.name}[${data.element_details.name}]`"
            v-model="field.value"
        />
    </div>
</template>

<script setup>
defineProps({
    data:Object,
    field:Object,
    step:Object,
    modelValue: String
})
const emit = defineEmits(['update:modelValue']);
</script>